import React from 'react';
import '../styles/Wonders.css';

const Wonders = ({ wonders, isLoading, openLightbox }) => {
  return (
    <section id="wonders" className="py-24 px-6 bg-emerald-100/30">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-16">
          <span className="text-emerald-600 font-bold uppercase tracking-[0.2em] text-xs">The Local Treasure</span>
          <h2 className="text-3xl md:text-5xl font-bold mt-2 text-emerald-950">Wonders of Maredumilli</h2>
          <p className="text-gray-600 mt-4 leading-relaxed italic max-w-2xl mx-auto text-sm md:text-base">
            Explore the untamed beauty of the Eastern Ghats. Click a photo to view the full gallery.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {isLoading ? (
            Array.from({ length: 4 }).map((_, idx) => (
              <div 
                key={`skeleton-${idx}`} 
                className="relative rounded-[30px] overflow-hidden h-64 md:h-80 shadow-lg bg-gray-200 animate-pulse"
              >
              </div>
            ))
          ) : (
            wonders.map((item, index) => (
              <div 
                key={item.id || index} 
                className="relative rounded-[30px] overflow-hidden group h-64 md:h-80 shadow-lg cursor-pointer"
                onClick={() => openLightbox(0, item.gallery)}
              >
                <img src={item.gallery[0]} alt={item.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                <div className="absolute inset-0 place-overlay flex flex-col justify-end p-6">
                  <h4 className="text-lg md:text-xl font-bold text-white leading-tight">{item.title}</h4>
                  <p className="text-emerald-300 text-[10px] mt-1 uppercase tracking-wider font-bold">
                    <i className="fas fa-images mr-1"></i> {item.gallery.length} Photos
                  </p>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </section>
  );
};

export default Wonders;
